module.exports = __webpack_public_path__ + "static/img/Wheel Of Fortune.aa81870.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Wheel Of Fortune.jpg
// module id = 1333
// module chunks = 0